import React from "react";
import { Link } from "react-router-dom";
import { MASCOT_ICONS } from "../lib/icons";
import { useLang } from "../lib/i18n";

export default function MascotCard({ mascot }) {
  const { t } = useLang();
  const Icon = MASCOT_ICONS[mascot.icon] ?? MASCOT_ICONS.Flame;
  const fg = mascot.color;
  return (
    <Link
      to={`/mascot/${mascot.id}`}
      data-testid={`mascot-card-${mascot.id}`}
      className="group relative overflow-hidden block bg-white border border-[#E8E6E1] rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_12px_40px_rgb(0,0,0,0.10)] hover:-translate-y-1 transition-all duration-300"
    >
      <div className="aspect-square bg-[#F4F1DE] overflow-hidden" data-testid={`mascot-cover-${mascot.id}`}>
        <img
          src={`/covers/${mascot.id}.jpg`}
          alt=""
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5 relative">
        <div
          className="absolute -top-6 right-5 w-12 h-12 rounded-2xl grid place-items-center text-white shadow-lg ring-4 ring-white"
          style={{ background: fg }}
        >
          <Icon className="w-6 h-6" strokeWidth={2.2} />
        </div>
        <div className="text-xs uppercase tracking-wider text-[#8A8D91] font-semibold">{mascot.animal}</div>
        <div className="font-heading text-2xl text-[#3D405B] leading-tight mt-0.5">{mascot.name}</div>
        <div className="mt-2 text-sm font-semibold" style={{ color: fg }}>{mascot.emotion}</div>
        <div className="text-sm text-[#8A8D91]">{mascot.tagline}</div>
        <div className="mt-3 inline-flex items-center gap-1 text-sm font-semibold" style={{ color: fg }}>
          {t("mascot.explore")} <span className="transition-transform group-hover:translate-x-1">→</span>
        </div>
      </div>
    </Link>
  );
}
